import { render, staticRenderFns } from "./NodeRedactorFrame.vue?vue&type=template&id=5a4a97b8&scoped=true"
import script from "./NodeRedactorFrame.vue?vue&type=script&lang=js"
export * from "./NodeRedactorFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a97b8",
  null
  
)

export default component.exports